import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent {}
